import { Navigate, Outlet } from 'react-router-dom';
import invariant from 'tiny-invariant';

import { LoadingPage } from '../components/LoadingPage';
import { LocaleSwitch } from '../components/locale-switch/LocaleSwitch';
import { ThemeSwitch } from '../components/ThemeSwitch';
import { useFetchUser } from '../hooks/useFetchUser';

export const SubscriptionLayout = () => {
  const { data: user, isLoading } = useFetchUser();

  if (isLoading) {
    return <LoadingPage />;
  }

  invariant(user);

  if (user.status !== 'SUBSCRIPTION') {
    return <Navigate to="/" />;
  }

  return (
    <div className="min-h-screen h-auto relative">
      <Outlet />
      <div className="absolute top-4 right-4 flex flex-row items-center gap-2">
        <ThemeSwitch />
        <LocaleSwitch />
      </div>
    </div>
  );
};
